import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { redirect } from "react-router-dom";
import { AuthContext } from "../types";
import { RootState } from "./store";

export interface AuthState {
    user: AuthContext | undefined;
}

const authSlice = createSlice({
    name: 'auth',
    initialState: {} as AuthState,
    reducers: {
        setAuth: (state, args: PayloadAction<AuthContext>) => {
            state.user = args.payload;
            localStorage.setItem('user', JSON.stringify(args.payload))
        },
        logout: (state, args: PayloadAction<any>) => {
            state.user = undefined;
            localStorage.removeItem('user');
            redirect('/login');
        }
    }
})

export const { setAuth, logout } = authSlice.actions;
export const authReducer = authSlice.reducer;
export const selectUser = (root: RootState) => root.auth.user;